var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-image", {
    ref: "image",
    staticClass: "c-table_image",
    attrs: {
      src: _vm.urls[0] || "",
      fit: _vm.fit,
      "preview-src-list": _vm.isPreview ? _vm.urls : [],
    },
    on: {
      load: () => {
        _vm.$emit("on-load")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "placeholder",
        fn: function () {
          return [
            _c("div", { staticClass: "image-slot" }, [
              _vm._v("加载中"),
              _c("span", { staticClass: "dot" }, [_vm._v("...")]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "error",
        fn: function () {
          return [
            _vm.isShowImageError
              ? _c("div", { staticClass: "image-slot" }, [
                  _c("i", { staticClass: "el-icon-picture-outline" }),
                ])
              : _c("div"),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }